import { render, staticRenderFns } from "./DocumentsListItem.vue?vue&type=template&id=0e84aea0&scoped=true&"
import script from "./DocumentsListItem.vue?vue&type=script&lang=js&"
export * from "./DocumentsListItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsListItem.vue?vue&type=style&index=0&id=0e84aea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e84aea0",
  null
  
)

export default component.exports